module.exports = __webpack_public_path__ + "img/horizontal_7_5_7005.e9e62887.png";